import { topList, topicRail } from "@/mocks/gossip";

export default function Rank() {
  return (
    <section id="rank" className="scroll-mt-20 border-y border-stone-200/70 bg-white">
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="flex flex-col gap-8 lg:flex-row">
          <div className="lg:flex-1">
            <h2 className="flex items-center gap-2 text-xl font-extrabold text-stone-900 md:text-2xl">
              热度榜<i className="ri-fire-line text-orange-500"></i>
            </h2>
            <p className="mt-1.5 text-sm text-stone-600">按最近 24 小时讨论热度排序，箭头代表相比上一期的位次变化。</p>

            <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
              {topList.map((item) => (
                <li
                  key={item.rank}
                  className="group flex items-center gap-3 rounded-xl border border-stone-200/80 bg-[#FFFDF8] px-3 py-3 transition-colors hover:border-orange-300"
                >
                  <span
                    className={`flex w-7 shrink-0 justify-center text-lg font-black ${
                      item.rank <= 3 ? "text-orange-500" : "text-stone-300"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-stone-800 group-hover:text-orange-600">
                      {item.title}
                    </p>
                  </div>
                  <span
                    className={`inline-flex shrink-0 items-center gap-0.5 text-xs font-medium ${
                      item.delta > 0 ? "text-orange-500" : item.delta < 0 ? "text-stone-400" : "text-stone-400"
                    }`}
                  >
                    {item.delta > 0 ? (
                      <i className="ri-arrow-up-line"></i>
                    ) : item.delta < 0 ? (
                      <i className="ri-arrow-down-line"></i>
                    ) : (
                      <i className="ri-more-line"></i>
                    )}
                    {item.delta > 0 ? `+${item.delta}` : item.delta < 0 ? item.delta : "持平"}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <aside className="lg:w-80">
            <div className="rounded-xl border border-stone-200/80 bg-[#F4EDE2] p-5">
              <h3 className="flex items-center gap-2 text-base font-bold text-stone-900">
                <i className="ri-price-tag-3-line text-emerald-700"></i>按题材分区找瓜
              </h3>
              <p className="mt-1.5 text-sm text-stone-600">不同专区各自独立归档，同类事件集中，方便按需挑着看。</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {topicRail.map((t) => (
                  <span
                    key={t.name}
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white px-3 py-1.5 text-sm text-stone-700 transition-colors hover:bg-emerald-50 hover:text-emerald-800"
                  >
                    {t.name}
                    <span className="text-xs text-stone-400">{t.num}</span>
                  </span>
                ))}
              </div>
              <div className="mt-4 flex items-start gap-2 rounded-lg bg-emerald-100/70 p-3 text-sm text-emerald-900">
                <i className="ri-information-line mt-0.5 shrink-0"></i>
                <span>所有分区均可多瓜连吃，按事件时间先后串联，不遗漏前因后果。</span>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}